import React, { useRef, useState } from "react";
import { Button } from "primereact/button";
import { Image } from "primereact/image";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import { RadioButton } from "primereact/radiobutton";
import { InputText } from "primereact/inputtext";
import axios from "axios";

const ProjectCostCalculator = () => {
  const stepperRef = useRef(null);
  const [projectName, setProjectName] = useState("");
  const [projectType, setProjectType] = useState("");
  const [platform, setPlatform] = useState("");
  const [budget, setBudget] = useState("");
  const [cost, setCost] = useState(0);
  const [sector, setSector] = useState("");
  const [clientName, setClientName] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [clientPhone, setClientPhone] = useState("");
  const [message, setMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const options = [
    {
      label: "موقع الكتروني",
      value: "website",
      cost: 100,
      icon: "fas fa-globe", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "تطبيق جوال",
      value: "mobile-app",
      cost: 5000,
      icon: "fas fa-mobile-alt", // أيقونة مناسبة من FontAwesome
    },
  ];

  const platformOptions = [
    {
      label: "أندرويد",
      value: "android",
      cost: 1900,
      icon: "fab fa-android", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "آي أو إس",
      value: "ios",
      cost: 1900,
      icon: "fab fa-apple", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "الكل",
      value: "all",
      cost: 2900,
      icon: "fas fa-globe", // أيقونة مناسبة من FontAwesome
    },
  ];

  const budgetOptions = [
    {
      label: "ميزانية صغيرة",
      value: "small",
      cost: 100,
      icon: "fas fa-wallet", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "ميزانية متوسطة",
      value: "medium",
      cost: 900,
      icon: "fas fa-wallet", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "ميزانية كبيرة",
      value: "large",
      cost: 1300,
      icon: "fas fa-wallet", // أيقونة مناسبة من FontAwesome
    },
  ];

  const sectorOptions = [
    {
      label: "عيادات",
      value: "clinic",
      cost: 200,
      icon: "fas fa-hospital", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "مكاتب محاماة",
      value: "law-office",
      cost: 200,
      icon: "fas fa-briefcase", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "طبي",
      value: "medical",
      cost: 200,
      icon: "fas fa-stethoscope", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "صيانة",
      value: "maintenance",
      cost: 200,
      icon: "fas fa-tools", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "التجارة الإلكترونية",
      value: "e-commerce",
      cost: 200,
      icon: "fas fa-shopping-cart", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "التعليم",
      value: "education",
      cost: 200,
      icon: "fas fa-book", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "الرعاية الصحية",
      value: "healthcare",
      cost: 200,
      icon: "fas fa-heart", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "المالية",
      value: "finance",
      cost: 200,
      icon: "fas fa-money-bill-alt", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "الطاقة",
      value: "energy",
      cost: 200,
      icon: "fas fa-lightbulb", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "العقارات",
      value: "real-estate",
      cost: 200,
      icon: "fas fa-building", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "السفر والسياحة",
      value: "travel-tourism",
      cost: 200,
      icon: "fas fa-plane", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "التكنولوجيا",
      value: "technology",
      cost: 200,
      icon: "fas fa-desktop", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "مطعم",
      value: "restaurant",
      cost: 200,
      icon: "fas fa-utensils", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "مدرسة",
      value: "school",
      cost: 200,
      icon: "fas fa-school", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "مستشفى",
      value: "hospital",
      cost: 200,
      icon: "fas fa-hospital", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "مركز تدريب",
      value: "training-center",
      cost: 200,
      icon: "fas fa-briefcase", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "خدمات النقل",
      value: "transport-services",
      cost: 200,
      icon: "fas fa-bus", // أيقونة مناسبة من FontAwesome
    },
    {
      label: "أنظمة خاصة",
      value: "management-systems",
      cost: 200,
      icon: "fas fa-code", // أيقونة مناسبة من FontAwesome
    },
  ];

  const calculateCost = () => {
    let baseCost = 0;
    // Find the cost of the selected project type
    const selectedProjectType = options.find(
      (option) => option.value === projectType
    );
    if (selectedProjectType) {
      baseCost += selectedProjectType.cost;
    }

    // Find the cost of the selected platform
    const selectedPlatform = platformOptions.find(
      (option) => option.value === platform
    );
    if (selectedPlatform) {
      baseCost += selectedPlatform.cost;
    }

    // Find the cost of the selected feature
    const selectedBudget = budgetOptions.find(
      (option) => option.value === budget
    );
    if (selectedBudget) {
      baseCost += selectedBudget.cost;
    }

    // Find the cost of the selected sector
    const selectedSector = sectorOptions.find(
      (option) => option.value === sector
    );
    if (selectedSector) {
      baseCost += selectedSector.cost;
    }

    if (projectType === "website") {
      // Special case handling for "e-commerce" sector with "small" budget
      if (sector === "e-commerce" && budget === "small") {
        baseCost = 420; // Special calculation for this specific case
      }

      if (sector === "e-commerce" && budget === "medium") {
        baseCost = 900; // Special calculation for this specific case
      }

      if (sector === "e-commerce" && budget === "large") {
        baseCost = 5000; // Special calculation for this specific case
      }

      if (sector === "management-systems" && budget === "small") {
        baseCost = 12000; // Special calculation for this specific case
      }

      if (sector === "management-systems" && budget === "medium") {
        baseCost = 23000; // Special calculation for this specific case
      }

      if (sector === "management-systems" && budget === "large") {
        baseCost = 36000; // Special calculation for this specific case
      }
    }

    setCost(baseCost);
  };

  const handleSubmit = async () => {
    if (!clientName || !clientEmail) {
      alert("يرجى إدخال الاسم والبريد الإلكتروني");
      return;
    }
    setIsLoading(true); // Show spinner

    // Prepare the data
    const formData = new URLSearchParams();
    formData.append("entry.287751264", projectName);
    formData.append(
      "entry.19532302",
      options.find((option) => option.value === projectType)?.label
    );
    formData.append(
      "entry.1131048070",
      sectorOptions.find((option) => option.value === sector)?.label
    );

    if (platform)
      formData.append(
        "entry.1235286107",
        platformOptions.find((option) => option.value === platform)?.label
      );
    formData.append(
      "entry.748064595",
      budgetOptions.find((option) => option.value === budget)?.label
    );
    formData.append("entry.1468088414", cost);

    formData.append("entry.189037252", clientName); // Replace 'entry.123456789' with your field ID
    formData.append("entry.245947007", clientEmail);
    formData.append("entry.2007699215", clientPhone);

    try {
      const googleFormUrl =
        "https://banafsijy.com/wp-content/themes/cena/google-form-proxy.php";
      await axios.post(googleFormUrl, formData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      setMessage("تم إرسال التفاصيل بنجاح. سنقوم بالرد عليك قريباً.");
      // Optionally, redirect or clear form
    } catch (error) {
      setMessage("فشل في إرسال التفاصيل. حاول مرة أخرى.");
      //   alert("حدث خطأ أثناء إرسال التفاصيل.");
    } finally {
      setIsLoading(false); // Hide spinner
    }
  };

  return (
    <div className="card">
      <Stepper ref={stepperRef} style={{ flexBasis: "50rem" }}>
        <StepperPanel header="اسم المشروع">
          <div className="flex flex-column align-items-center gap-3 mb-4">
            <h3 className="mb-3">مرحبا بك في حاسبة تكلفة المشروع!</h3>
            <p className="mb-4">
              لتبدأ عملية حساب التكلفة التقديرية لمشروعك، يرجى إدخال اسم المشروع
              أولاً. اسم المشروع سيساعدنا على تقديم تقدير دقيق بناءً على
              التفاصيل التي ستقدمها لاحقاً.
            </p>

            <div className="flex flex-column align-items-center gap-3 mb-4">
              <label htmlFor="projectName" className="font-bold">
                اسم المشروع
              </label>
              <InputText
                id="projectName"
                value={projectName}
                onChange={(e) => setProjectName(e.target.value)}
                placeholder="ادخل اسم المشروع"
                className="mb-4 w-15rem"
              />
              <Button
                label="ابدأ"
                icon="pi pi-arrow-left mr-5"
                iconPos="right"
                disabled={!projectName} // Disable until project name is entered
                onClick={() => {
                  if (projectName) {
                    stepperRef.current.nextCallback();
                  }
                }}
              />
              {!projectName && (
                <p className="text-red-500 mt-2">
                  <i className="pi pi-exclamation-triangle"></i> يجب إدخال اسم
                  المشروع لبدء الحساب.
                </p>
              )}
            </div>
          </div>
        </StepperPanel>
        <StepperPanel header="اختر نوع المشروع">
          <div className="flex justify-content-center h-12rem">
            {options.map((option, index) => (
              <div
                key={index}
                className="flex align-items-center mb-4 item-option"
              >
                <RadioButton
                  inputId={option.label}
                  name="projectType"
                  value={option.value}
                  onChange={(e) => setProjectType(e.value)}
                  checked={projectType === option.value}
                  style={{ display: "none" }}
                />
                <label
                  htmlFor={option.label}
                  className={
                    "ml-2" + (projectType === option.value ? " selected" : "")
                  }
                  onClick={() => setProjectType(option.value)}
                >
                  {/* <Image src={option.image} alt={option.label} /> */}
                  <i className={option.icon}></i>
                  <span className="ml-2">{option.label}</span>
                </label>
              </div>
            ))}
          </div>
          <div className="flex pt-4 justify-content-between">
            <Button
              label="العودة"
              severity="secondary"
              icon="pi pi-arrow-right ml-3"
              onClick={() => stepperRef.current.prevCallback()}
            />
            <Button
              label="التالي"
              icon="pi pi-arrow-left mr-3"
              iconPos="right"
              onClick={() => stepperRef.current.nextCallback()}
            />
          </div>
        </StepperPanel>

        <StepperPanel header="اختر قطاع المشروع">
          <div className="flex justify-content-center flex-wrap">
            {sectorOptions.map((option, index) => (
              <div
                key={index}
                className="flex align-items-center mb-4 item-option"
              >
                <RadioButton
                  inputId={option.label}
                  name="sector"
                  value={option.value}
                  onChange={(e) => setSector(e.value)}
                  checked={sector === option.value}
                  style={{ display: "none" }}
                />
                <label
                  htmlFor={option.label}
                  className={
                    "ml-2" + (sector === option.value ? " selected" : "")
                  }
                  onClick={() => setSector(option.value)}
                >
                  {/* <Image
                    src={option.image}
                    alt={option.label}
                    width={24}
                    height={24}
                  /> */}
                  <i className={option.icon}></i>

                  <span className="ml-2">{option.label}</span>
                </label>
              </div>
            ))}
          </div>
          <div className="flex pt-4 justify-content-between">
            <Button
              label="العودة"
              severity="secondary"
              icon="pi pi-arrow-right ml-3"
              onClick={() => stepperRef.current.prevCallback()}
            />
            <Button
              label="التالي"
              icon="pi pi-arrow-left mr-3"
              iconPos="right"
              onClick={() => stepperRef.current.nextCallback()}
            />
          </div>
        </StepperPanel>

        {projectType == "mobile-app" && (
          <StepperPanel header="اختر نظام التطبيق">
            <div className="flex justify-content-center h-12rem flex-wrap">
              {platformOptions.map((option, index) => (
                <div
                  key={index}
                  className="flex align-items-center mb-4  item-option"
                >
                  <RadioButton
                    inputId={option.label}
                    name="platform"
                    value={option.value}
                    onChange={(e) => setPlatform(e.value)}
                    checked={platform === option.value}
                    style={{ display: "none" }}
                  />
                  <label
                    htmlFor={option.label}
                    className={
                      "ml-2" + (platform === option.value ? " selected" : "")
                    }
                    onClick={() => setPlatform(option.value)}
                  >
                    {/* <Image src={option.image} alt={option.label} /> */}
                    <i className={option.icon}></i>

                    <span className="ml-2">{option.label}</span>
                  </label>
                </div>
              ))}
            </div>
            <div className="flex pt-4 justify-content-between">
              <Button
                label="العودة"
                severity="secondary"
                icon="pi pi-arrow-right ml-3"
                onClick={() => stepperRef.current.prevCallback()}
              />
              <Button
                label="التالي"
                icon="pi pi-arrow-left mr-3"
                iconPos="right"
                onClick={() => stepperRef.current.nextCallback()}
              />
            </div>
          </StepperPanel>
        )}

        <StepperPanel header="اختر ميزانية المشروع">
          <div className="flex justify-content-center flex-wrap">
            {budgetOptions.map((option, index) => (
              <div
                key={index}
                className="flex align-items-center mb-4 item-option"
              >
                <RadioButton
                  inputId={option.label}
                  name="budget"
                  value={option.value}
                  onChange={(e) => setBudget(e.value)}
                  checked={budget === option.value}
                  style={{ display: "none" }}
                />
                <label
                  htmlFor={option.label}
                  className={
                    "ml-2" + (budget === option.value ? " selected" : "")
                  }
                  onClick={() => setBudget(option.value)}
                >
                  {/* <Image
                    src={option.image}
                    alt={option.label}
                    width={24}
                    height={24}
                  /> */}
                  <i className={option.icon}></i>

                  <span className="ml-2">{option.label}</span>
                </label>
              </div>
            ))}
          </div>
          <div className="flex pt-4 justify-content-between">
            <Button
              label="العودة"
              severity="secondary"
              icon="pi pi-arrow-right ml-3"
              onClick={() => stepperRef.current.prevCallback()}
            />
            <Button
              label="إحسب التكلفة"
              icon="pi pi-arrow-left mr-3"
              iconPos="right"
              onClick={() => {
                calculateCost();
                stepperRef.current.nextCallback();
              }}
            />
          </div>
        </StepperPanel>

        <StepperPanel header="نتيجة الحساب">
          <div className="grid justify-content-between">
            <div className="flex flex-column align-items-center col-12 md:col-6">
              {cost > 0 && (
                <>
                  <h3>التكلفة التقديرية: {cost} ريال</h3>
                  <div className="mt-2 ">
                    <h4>تفاصيل مشروع: {projectName}</h4>
                    <ul className="list-none pr-0">
                      <li>
                        نوع المشروع:{" "}
                        {options.find((option) => option.value === projectType)
                          ?.label || "غير محدد"}
                      </li>
                      {projectType == "mobile-app" && (
                        <li>
                          نظام التطبيق:{" "}
                          {platformOptions.find(
                            (option) => option.value === platform
                          )?.label || "غير محدد"}
                        </li>
                      )}
                      <li>
                        القطاع:{" "}
                        {sectorOptions.find((option) => option.value === sector)
                          ?.label || "غير محدد"}
                      </li>
                      <li>
                        الميزانية:{" "}
                        {budgetOptions.find((option) => option.value === budget)
                          ?.label || "غير محدد"}
                      </li>
                    </ul>
                  </div>
                  <p>
                    هل تحتاج إلى مزيد من الخدمات لتعزيز مشروعك؟ اكتشف المزيد من
                    الخدمات المتاحة لدينا:
                  </p>
                  <Button
                    label={`تصفح الخدمات المتاحة بتكلفة تقديرية ${cost} ريال`}
                    icon="pi pi-shopping-cart mr-3"
                    iconPos="right"
                    onClick={() =>
                      window.open(
                        `https://banafsijy.com/${
                          projectType === "website"
                            ? "product-category/website-development/"
                            : "product-category/mobile-apps/"
                        }?max_price=${cost}`,
                        "_blank"
                      )
                    }
                  />
                </>
              )}
              {cost <= 0 && (
                <h3>
                  فضلاً أدخال معلومات المشروع اولاً، لحساب التكلفة التقديرية
                </h3>
              )}
            </div>
            <div className="flex flex-column align-items-center pt-4 col-12 md:col-6">
              {cost > 0 && (
                <>
                  <h4>إدخال بياناتك لإرسال كافة التفاصيل والنماذج:</h4>
                  <div className="flex flex-column gap-3">
                    <label htmlFor="clientName" className="font-bold">
                      اسم العميل
                    </label>
                    <InputText
                      id="clientName"
                      value={clientName}
                      onChange={(e) => setClientName(e.target.value)}
                      placeholder="ادخل اسمك"
                      className="w-15rem"
                    />
                    <label htmlFor="clientEmail" className="font-bold">
                      البريد الإلكتروني
                    </label>
                    <InputText
                      id="clientEmail"
                      value={clientEmail}
                      onChange={(e) => setClientEmail(e.target.value)}
                      placeholder="ادخل بريدك الإلكتروني"
                      className="w-15rem"
                    />
                    <label htmlFor="clientPhone" className="font-bold">
                      رقم الجوال
                    </label>
                    <InputText
                      id="clientPhone"
                      value={clientPhone}
                      onChange={(e) => setClientPhone(e.target.value)}
                      placeholder="ادخل رقم جوالك "
                      className="w-15rem"
                    />
                  </div>
                  <div className="flex pt-4 justify-content-between gap-1">
                    <Button
                      label="إرسال التفاصيل"
                      disabled={isLoading}
                      icon={
                        isLoading
                          ? "fas fa-spinner fa-pulse  mr-3"
                          : "pi pi-send mr-3"
                      }
                      iconPos="right"
                      onClick={handleSubmit}
                    />
                  </div>
                  {message && (
                    <p className="pt-2 text-primary-700">{message}</p>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="flex">
            <Button
              label="العودة"
              severity="secondary"
              icon="pi pi-arrow-right ml-3"
              onClick={() => stepperRef.current.prevCallback()}
            />
          </div>
        </StepperPanel>
      </Stepper>
    </div>
  );
};

export default ProjectCostCalculator;
